import { motion } from 'motion/react';
import { useState } from 'react';

const TagSortingIcon = ({ onSort }) => {
    const [isActive, setIsActive] = useState(false);
    const [sortDirection, setSortDirection] = useState('desc'); // 'desc' for newest first, 'asc' for oldest first

    const handleClick = () => {
        const newDirection = sortDirection === 'desc' ? 'asc' : 'desc';
        setSortDirection(newDirection);
        setIsActive(true);

        // Call the sort function if provided
        if (onSort) {
            onSort(newDirection);
        }

        // Reset active state after animation
        setTimeout(() => setIsActive(false), 300);
    };

    return (
        <motion.button
            className="flex items-center gap-1 hover:text-orange-500 dark:hover:text-orange-300 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50 rounded-sm px-1"
            onClick={handleClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            title={sortDirection === 'desc' ? '按日期排序 (最新優先)' : '按日期排序 (最舊優先)'}
            aria-label={`Sort posts by date (${sortDirection === 'desc' ? 'newest first' : 'oldest first'})`}
        >
            <motion.svg
                className="w-4 h-4"
                fill="currentColor"
                viewBox="0 0 20 20"
                animate={{
                    rotate: sortDirection === 'asc' ? 180 : 0,
                    scale: isActive ? 1.2 : 1
                }}
                transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 20
                }}
            >
                <motion.path
                    fillRule="evenodd"
                    d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clipRule="evenodd"
                    animate={{
                        fill: isActive ? '#ea580c' : 'currentColor'
                    }}
                    transition={{ duration: 0.2 }}
                />
            </motion.svg>
            <span className="text-xs font-medium">
                {sortDirection === 'desc' ? '最新' : '最舊'}
            </span>
        </motion.button>
    );
};

export default TagSortingIcon;